// src/services/globalService.js
import apiClient from './apiClient.js'

export const globalService = {
    getGlobalConfig() {
        return apiClient.get('/global')
    },

    updateGlobalConfig(data) {
        return apiClient.put('/global', data)
    },
}